import { useTranslation } from "react-i18next";
import { useAppSelector } from "store";

/** The Browzwear card's frame (name, one-line description, status chip) — one source for /integrations and Account → Connected Apps. */
const useBrowzwearCardProps = () => {
  const { t } = useTranslation();
  const { browzwear } = useAppSelector((state) => state.common);

  return {
    brand: "browzwear" as const,
    name: t("account:integrations.browzwear_name"),
    description: t("account:integrations.browzwear_description"),
    status: browzwear.isConnected ? t("account:integrations.status_connected_store", { store: browzwear.storeName }) : t("account:integrations.status_not_connected"),
    statusTone: browzwear.isConnected ? ("ok" as const) : ("idle" as const),
  };
};

export default useBrowzwearCardProps;
